const win = typeof window === 'undefined' ? {} : window;
const cssNumber = {
  'column-count': 1,
  columns: 1,
  'font-weight': 1,
  'line-height': 1,
  opacity: 1,
  'z-index': 1,
  zoom: 1,
};

function on(element, ev, callback) {
  if (typeof ev === 'string') {
    element.addEventListener(ev, callback, { passive: true });
  } else if (Array.isArray(ev)) {
    ev.forEach((e) => on(element, e, callback));
  }
}

function off(element, ev, callback) {
  if (typeof ev === 'string') {
    element.removeEventListener(ev, callback, { passive: true });
  } else if (Array.isArray(ev)) {
    ev.forEach((e) => off(element, e, callback));
  }
}

function one(element, ev, callback) {
  function handler(...args) {
    callback.apply(this, args);
    off(element, ev, handler);
  }

  on(element, ev, handler);
}

function camelize(str) {
  return str.replace(/-+(.)?/g, (match, chr) => (chr ? chr.toUpperCase() : ''));
}

function dasherize(str) {
  return str
    .replace(/::/g, '/')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/([a-z\d])([A-Z])/g, '$1_$2')
    .replace(/_/g, '-')
    .toLowerCase();
}

function maybeAddPx(name, value) {
  return typeof value === 'number' && !cssNumber[dasherize(name)] ? `${value}px` : value;
}

function css(element, property, value) {
  const elementSytle = element.style;
  if (arguments.length < 3) {
    return (
      elementSytle[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property)
    );
  }
  if (!value && value !== 0) {
    elementSytle.removeProperty(dasherize(property));
  } else {
    elementSytle[dasherize(property)] = maybeAddPx(property, value);
  }
  return undefined;
}

function offset(element) {
  const obj = element.getBoundingClientRect();
  return {
    left: obj.left + win.pageXOffset,
    top: obj.top + win.pageYOffset,
    width: Math.round(obj.width),
    height: Math.round(obj.height),
  };
}

function width(element) {
  return offset(element).width;
}

export const $ = {
  on,
  off,
  one,
  css,
  offset,
  width,
};
